import { Theme } from '@mui/material';

export default {
    iconStyle: { fontSize: '14px', color: (theme: Theme) => theme.palette.text.secondary, cursor: 'move' },
};
